export enum ModeEnum {
  mailRead,
  mailCompose,
  office,
  contentManager,
  contentManagerAdvancedSearch,
  contentManagerTeams
}

export const getModeDisplayText = (mode: ModeEnum): string => {
  switch (mode) {
    case ModeEnum.mailRead:
      return "Mail Read";
    case ModeEnum.mailCompose:
      return "Mail Compose";
    case ModeEnum.office:
      return "Office";
    case ModeEnum.contentManager:
      return "Content Manager";
    case ModeEnum.contentManagerAdvancedSearch:
      return "Advanced Search";
    case ModeEnum.contentManagerTeams:
      return "Teams";
    default:
      return "Unknown Mode";
  }
};